import { IRawStep, IRawVariant, IVariant } from 'models/variant.model'

import { PageId } from 'page-constants'

const mapRawStep = (step: IRawStep) => ({
  id: step.page_id === PageId.EMAIL_WELLNESS ? PageId.ACCOUNT : step.page_id,
  isPayment: step.is_payment,
  isUpsell: step.is_upsell,
  isQuestion: step.is_question,
  isSkippable: step.is_skippable,
  isSubscriptions: step.is_subscriptions,
  hasHeader: step.has_header,
  hasProgressBar: step.has_progressbar,
})

export const getVariantFromRawVariant = (
  rawVariant: IRawVariant,
): IVariant => ({
  cohort: rawVariant.cohort_id,
  parentCohort: rawVariant.parent_cohort_id,
  facebookPixelIds: rawVariant.facebook_pixel_ids,
  applovinPixelId: rawVariant.applovin_pixel_id,
  googleAnalyticsId: rawVariant.google_analytics_id,
  googleAdsConversions: rawVariant.google_ads_conversions,
  growthBookExperiments: rawVariant.optimize_map,
  pinterestTagId: rawVariant.pinterest_tag_id,
  hasCancelOffer: rawVariant.has_cancel_offer,
  hasUpsellOffer: rawVariant.has_upsell_offer,
  hasInAppOffer: rawVariant.has_inapp_offer,
  abSegmentName: rawVariant.ab_segment_name,
  tiktokPixelId: rawVariant.tiktok_pixel_id,
  snapPixelId: rawVariant.snap_pixel_id,
  outbrainPixelId: rawVariant.outbrain_pixel_id,
  taboolaPixelId: rawVariant.taboola_pixel_id,
  redditPixelId: rawVariant.reddit_pixel_id,
  growthbookFeatureKey: rawVariant.growthbook_feature_key || '',
  steps: rawVariant.steps.map(mapRawStep),
  stepsV2: {
    a: (rawVariant.steps_v2?.a ?? rawVariant.steps).map(mapRawStep),
    b: (rawVariant.steps_v2?.b ?? []).map(mapRawStep),
    c: (rawVariant.steps_v2?.c ?? []).map(mapRawStep),
    d: (rawVariant.steps_v2?.d ?? []).map(mapRawStep),
  },
})
